import React from 'react';
import { motion } from 'framer-motion';
import Bg from '../../images/ui/dark-blue-bg.jpg';
import VideoBg from '../../video/blue-bg.mp4';
import Head from '../../images/evidence/brain-response-head.png';
import NoiseBlocks from '../../images/evidence/brain-response-noise-blocks.png';
import MagentaLine from '../elements/MagentaLine';

export default function BrainResponse() {
  const BASE_TIME = 2.2;
  return (
    <div className="evidence-subpage" id="brain-response">
      <img src={Bg} className="full-bg" />
      <motion.video
        src={VideoBg}
        className="full-bg"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2, delay: 0.5 }}
        loop
        autoPlay
        muted
      />
      <header>
        <MagentaLine height="97px" left="19px" />
        <div className="wordwrap" style={{ left: '22px' }}>
          <motion.div
            className="first-line"
            style={{
              fontSize: '18px',
              top: '26px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            Evidence
          </motion.div>
          <motion.div
            className="second-line"
            style={{
              fontSize: '22px',
              top: '70px',
              letterSpacing: '0.8px',
            }}
            initial={{ x: -982 }}
            animate={{ x: 0 }}
            transition={{ duration: 0.8, delay: 1.4 }}
          >
            Test Setup: Brain responses (EEG)
          </motion.div>
        </div>
      </header>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 4.4 }}
        id="circle"
      />
      <motion.img
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 4.4 }}
        src={NoiseBlocks}
        id="noise-blocks"
      />
      <motion.img
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 4.4 }}
        src={Head}
        id="head"
      />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 0.4 }}
        id="purpose-block"
        className="text-block"
      >
        <div className="label" id="purpose">
          Purpose
        </div>
        <p>
          Measure how well the full sound scene is represented as it enters the
          brain with Oticon More™ vs Opn S™
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 1 }}
        id="participants-block"
        className="text-block"
      >
        <div className="label" id="participants">
          Participants
        </div>
        <ul>
          <li>Thirty-four experienced hearing-aid users</li>
          <li>Mild to moderate sensorineural hearing loss</li>
          <li>Mean age: 66 years</li>
        </ul>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, delay: BASE_TIME + 1.6 }}
        id="conditions-block"
        className="text-block"
      >
        <div className="label" id="conditions">
          Conditions
        </div>
        <ul>
          <li>Oticon More with MoreSound Intellignce OFF</li>
          <li>Oticon More with MoreSound Intellignce ON</li>
          <li>Oticon Opn S with OpenSound Navigator ON</li>
        </ul>
      </motion.div>
    </div>
  );
}
